import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-dr-dish-login',
  templateUrl: './dr-dish-login.component.html',
  styleUrls: [
    '../style/global.css',
    '../dr-dish/dr-dish.component.css',
    './dr-dish-login.component.css',
  ],
})
export class DrDishLoginComponent extends BaseLoginComponent implements OnInit {
  async init(): Promise<void> {}
}
